import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './GallectionSimpleView';
import { AppState } from '../../../../../types/store';
import { setCurrentlyViewedFolderId } from '../../../../actions/gallectionSection';
import { getCurrentlyViewedFolder } from '../../../../selectors/gallectionSection';
import {
  getCurrentAdSafety,
  getSafetyState,
} from '@wix/da-shared-react/pkg/Ads/redux/selectors';

export type StateProps = Pick<
  Props,
  'currentFolder' | 'adSafety' | 'adSafetyState'
>;
export type DispatchProps = Pick<Props, 'setCurrentlyViewedFolderId'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  return {
    currentFolder: getCurrentlyViewedFolder(state),
    adSafety: getCurrentAdSafety(state) || '',
    adSafetyState: getSafetyState(state),
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  setCurrentlyViewedFolderId,
};

export default connect(mapStateToProps, mapDispatchToProps);
